import { ref } from 'vue';
import { useStore } from 'vuex';
import { toPng, toJpeg } from 'html-to-image';

import { i18n } from '@/i18n';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

export const maxScale = 17;
export const minScale = 1;

export default function useExportForm() {
  const store = useStore();
  const { track } = useTrack();

  const submitting = ref(false);
  const formData = ref(store.state.exportStore.formData);
  const scaleOptions: any[] = [];
  for (let i = minScale; i <= maxScale; i++) {
    scaleOptions.push({
      value: i.toString(),
      label: i.toString(),
    });
  }
  const projectionOptions = [
    {
      value: 'Web Mercator',
      label: i18n.global.t('ExportDrawer.projection.webmercator'),
    },
  ];
  const formatOptions = [
    {
      value: 'PNG',
      label: 'PNG',
    },
    {
      value: 'JPG',
      label: 'JPG',
    },
  ];

  const exportMapAsHighResImage = async () => {
    const { format, title, description } = store.state.exportStore.formData;
    const container = document.getElementById('export-preview') as HTMLElement;
    const filter = (node: HTMLElement) => {
      const exclusionClasses: string[] = ['ql-toolbar'];
      if (!title) {
        exclusionClasses.push('map-title');
      }
      if (!description || !description.trim()) {
        exclusionClasses.push('map-description');
      }
      return !exclusionClasses.some((classname) =>
        node.classList?.contains(classname),
      );
    };
    const options = {
      pixelRatio: 2,
      quality: 1, // 设置为 1 以获得最高质量
      backgroundColor: 'white',
      filter,
    };

    // 使用 html-to-image 将地图转换为 PNG 图片
    const dataUrl =
      format == 'PNG'
        ? await toPng(container, options)
        : await toJpeg(container, options);

    // // 创建一个链接以下载图片
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `download.${format.toLowerCase()}`;
    link.click();
    submitting.value = false;
  };

  const updateFormData = (field: string, value: any) => {
    store.commit('exportStore/updateFormData', { [field]: value });
  };

  const submitFormData = () => {
    submitting.value = true;
    exportMapAsHighResImage();
  };

  const onScaleChange = (value: string) => {
    store.state.exportStore.mapData.mainMap.setZoom(parseInt(value));

    track(FunctionIdEnum.globalLayer_export_selectZoom, EventTypeEnum.CLICK);
  };

  const onSwitchNorthChange = (show: boolean) => {
    track(FunctionIdEnum.globalLayer_export_showNorth, EventTypeEnum.CLICK, {
      show,
    });
  };

  const onSwitchGridChange = (show: boolean) => {
    track(
      FunctionIdEnum.globalLayer_export_showGratiules,
      EventTypeEnum.CLICK,
      {
        show,
      },
    );
  };

  const onSwitchMiniMapChange = (show: boolean) => {
    track(FunctionIdEnum.globalLayer_export_showMiniMap, EventTypeEnum.CLICK, {
      show,
    });
  };

  const onExportFormatChange = (type: string) => {
    track(
      FunctionIdEnum.globalLayer_export_selectExportFormat,
      EventTypeEnum.CLICK,
      {
        type,
      },
    );
  };

  return {
    submitting,
    formData,
    scaleOptions,
    projectionOptions,
    formatOptions,
    onScaleChange,
    updateFormData,
    submitFormData,
    onSwitchNorthChange,
    onSwitchGridChange,
    onSwitchMiniMapChange,
    onExportFormatChange,
  };
}
